import { createSlice } from '@reduxjs/toolkit'

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        image: '',
        cover_photo: '',
        name: '',
        email: '',
        matricule: '',
        address: '',
        description: '',
        type: '',
        reference: '',
        shift: {
            start: '',
            end: '',
        },
        features: [],
        printers: [],
    },
    reducers: {
        setCompany: (_, action) => action.payload,
    },
})

export const { setCompany } = sessionSlice.actions

export default sessionSlice.reducer
